// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1wBTC","inputWrap":"styles_inputWrap___Vh6D","input":"styles_input__2auUS"};